"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var merge_1 = __importDefault(require("lodash/merge"));
var mobx_1 = require("mobx");
var constants_1 = __importDefault(require("../core/constants"));
var ViewStore = /** @class */ (function () {
    function ViewStore(rootStore, fullscreen) {
        /** If false, probably embedded on a website or on the studio */
        this.isFullscreen = true;
        this.unreadCount = 0;
        this.isConversationsDisplayed = false;
        this._isLoading = true;
        this._showBotInfo = false;
        this.isPoweredByDisplayed = true;
        this.focusedArea = mobx_1.observable.box('input');
        /** These buttons are displayed in the header, and can point to actions on your custom components */
        this.customButtons = [];
        this.customActions = [];
        this.disableAnimations = false;
        this.highlightedMessages = [];
        this.rootStore = rootStore;
        this.isFullscreen = fullscreen;
        this.activeView = fullscreen ? 'side' : 'widget';
        this.dimensions = {
            container: fullscreen ? '100%' : constants_1.default.DEFAULT_CONTAINER_WIDTH,
            layout: fullscreen ? '100%' : constants_1.default.DEFAULT_LAYOUT_WIDTH
        };
    }
    Object.defineProperty(ViewStore.prototype, "showConversationsButton", {
        get: function () {
            var _a, _b;
            return !((_a = this.rootStore.config) === null || _a === void 0 ? void 0 : _a.conversationId) && ((_b = this.rootStore.config) === null || _b === void 0 ? void 0 : _b.showConversationsButton);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewStore.prototype, "showBotInfoButton", {
        get: function () {
            return !this.isConversationsDisplayed && this.rootStore.botInfo && this.rootStore.botInfo.showBotInfoPage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewStore.prototype, "showDownloadButton", {
        get: function () {
            return !this.isConversationsDisplayed && !this.isBotInfoDisplayed && this.rootStore.config.enableTranscriptDownload;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewStore.prototype, "showDeleteConversationButton", {
        get: function () {
            return (!this.isConversationsDisplayed && !this.isBotInfoDisplayed && this.rootStore.config.enableConversationDeletion);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewStore.prototype, "showResetButton", {
        get: function () {
            var _a;
            return !this.isConversationsDisplayed && !this.isBotInfoDisplayed && ((_a = this.rootStore.config) === null || _a === void 0 ? void 0 : _a.enableReset);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewStore.prototype, "showCloseButton", {
        get: function () {
            return !this.isFullscreen;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewStore.prototype, "showWidgetButton", {
        get: function () {
            var _a;
            return !((_a = this.rootStore.config) === null || _a === void 0 ? void 0 : _a.hideWidget);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewStore.prototype, "hasUnreadMessages", {
        get: function () {
            return this.unreadCount > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewStore.prototype, "isWebchatReady", {
        get: function () {
            return !this._isLoading && this.activeView;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewStore.prototype, "isBotInfoDisplayed", {
        get: function () {
            return this._showBotInfo && this.rootStore.botInfo && this.rootStore.botInfo.showBotInfoPage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewStore.prototype, "sideTransition", {
        /** Returns the active transition for the side panel, like fade in or out */
        get: function () {
            var _a;
            return !this.isFullscreen && ((_a = this.transitions) === null || _a === void 0 ? void 0 : _a.sideTransition);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewStore.prototype, "widgetTransition", {
        get: function () {
            var _a;
            return (_a = this.transitions) === null || _a === void 0 ? void 0 : _a.widgetTransition;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewStore.prototype, "displayWidgetView", {
        get: function () {
            return this.activeView !== 'side' && !this.isFullscreen;
        },
        enumerable: false,
        configurable: true
    });
    /** Sets the current focus to that element */
    ViewStore.prototype.setFocus = function (element) {
        this.focusedArea.set(element);
    };
    ViewStore.prototype.focusPrevious = function () {
        var current = this._getFocusOrder(this.focusedArea.get());
        if (current) {
            this.setFocus(current.prev);
        }
    };
    ViewStore.prototype.focusNext = function () {
        var current = this._getFocusOrder(this.focusedArea.get());
        if (current) {
            this.setFocus(current.next);
        }
    };
    ViewStore.prototype.incrementUnread = function () {
        this.unreadCount++;
    };
    ViewStore.prototype.resetUnread = function () {
        this.unreadCount = 0;
    };
    ViewStore.prototype.toggleBotInfo = function () {
        this._showBotInfo = !this._showBotInfo;
    };
    ViewStore.prototype.showBotInfo = function () {
        this._showBotInfo = true;
    };
    ViewStore.prototype.toggleConversations = function () {
        this.isConversationsDisplayed = !this.isConversationsDisplayed;
    };
    ViewStore.prototype.hideConversations = function () {
        this.isConversationsDisplayed = false;
    };
    ViewStore.prototype.setLoadingCompleted = function () {
        this._isLoading = false;
        this.rootStore.postMessage('webchatLoaded');
    };
    ViewStore.prototype.showPoweredBy = function () {
        this.isPoweredByDisplayed = true;
    };
    ViewStore.prototype.hidePoweredBy = function () {
        this.isPoweredByDisplayed = false;
    };
    ViewStore.prototype.setLayoutWidth = function (width) {
        if (width) {
            this.dimensions.layout = typeof width === 'number' ? "".concat(width, "px") : width;
        }
    };
    ViewStore.prototype.setContainerWidth = function (width) {
        if (width) {
            this.dimensions.container = width = typeof width === 'number' ? "".concat(width, "px") : width;
        }
    };
    ViewStore.prototype.addCustomAction = function (newAction) {
        if (this.customActions.find(function (act) { return act.id === newAction.id; })) {
            console.error("Can't add another action with the same ID.");
            return;
        }
        this.customActions.push(newAction);
    };
    ViewStore.prototype.removeCustomAction = function (actionId) {
        this.customActions = this.customActions.filter(function (btn) { return btn.id !== actionId; });
    };
    ViewStore.prototype.addHeaderButton = function (newButton) {
        if (this.customButtons.find(function (btn) { return btn.id === newButton.id; })) {
            console.error("Can't add another button with the same ID.");
            return;
        }
        this.customButtons.push(newButton);
    };
    ViewStore.prototype.setHighlightedMessages = function (ids) {
        this.highlightedMessages = ids;
    };
    /** Updates one or multiple properties of a specific button */
    ViewStore.prototype.updateHeaderButton = function (buttonId, newProps) {
        var button = this.customButtons.find(function (btn) { return btn.id === buttonId; });
        button && (0, merge_1.default)(button, newProps);
    };
    ViewStore.prototype.removeHeaderButton = function (buttonId) {
        this.customButtons = this.customButtons.filter(function (btn) { return btn.id !== buttonId; });
    };
    ViewStore.prototype.showChat = function () {
        var _this = this;
        if (this.disableAnimations) {
            this.activeView = 'side';
            this.rootStore.postMessage('webchatOpened');
            return this._updateTransitions({ widgetTransition: undefined, sideTransition: 'none' });
        }
        this._updateTransitions({ widgetTransition: 'fadeOut' });
        this._endAnimation('side', {
            beforeViewChange: function () {
                _this._updateTransitions({ sideTransition: 'fadeIn' });
            }
        });
        this.rootStore.postMessage('webchatOpened');
    };
    ViewStore.prototype.hideChat = function () {
        var _this = this;
        if (this.isFullscreen) {
            return;
        }
        if (this.disableAnimations) {
            this.activeView = 'widget';
            this.rootStore.postMessage('webchatClosed');
            return this._updateTransitions({ widgetTransition: undefined, sideTransition: undefined });
        }
        this._updateTransitions({ sideTransition: 'fadeOut' });
        this._endAnimation('widget', {
            beforeViewChange: function () {
                if (!_this.activeView || _this.activeView === 'side') {
                    _this._updateTransitions({ widgetTransition: 'fadeIn' });
                }
            }
        });
        this.rootStore.postMessage('webchatClosed');
    };
    ViewStore.prototype._endAnimation = function (finalView, opts) {
        var _this = this;
        opts = opts || {};
        setTimeout(function () {
            (0, mobx_1.runInAction)(function () {
                opts.beforeViewChange && opts.beforeViewChange();
                _this.activeView = finalView;
            });
        }, constants_1.default.ANIM_DURATION);
        setTimeout(function () {
            _this._updateTransitions({
                widgetTransition: undefined,
                sideTransition: _this.transitions.sideTransition === 'fadeIn' && 'fadeIn'
            });
        }, constants_1.default.ANIM_DURATION * 2.1);
    };
    ViewStore.prototype._updateTransitions = function (trans) {
        this.transitions = trans;
    };
    ViewStore.prototype._getFocusOrder = function (current) {
        if (current === 'header') {
            return { prev: 'input', next: 'convo' };
        }
        else if (current === 'input' && !this.isConversationsDisplayed && !this.isBotInfoDisplayed) {
            return { prev: 'convo', next: 'header' };
        }
        else if (current === 'convo') {
            return { prev: 'header', next: 'input' };
        }
    };
    __decorate([
        mobx_1.observable
    ], ViewStore.prototype, "isFullscreen", void 0);
    __decorate([
        mobx_1.observable
    ], ViewStore.prototype, "unreadCount", void 0);
    __decorate([
        mobx_1.observable
    ], ViewStore.prototype, "dimensions", void 0);
    __decorate([
        mobx_1.observable
    ], ViewStore.prototype, "isConversationsDisplayed", void 0);
    __decorate([
        mobx_1.observable
    ], ViewStore.prototype, "activeView", void 0);
    __decorate([
        mobx_1.observable
    ], ViewStore.prototype, "transitions", void 0);
    __decorate([
        mobx_1.observable
    ], ViewStore.prototype, "_isLoading", void 0);
    __decorate([
        mobx_1.observable
    ], ViewStore.prototype, "_showBotInfo", void 0);
    __decorate([
        mobx_1.observable
    ], ViewStore.prototype, "isPoweredByDisplayed", void 0);
    __decorate([
        mobx_1.observable
    ], ViewStore.prototype, "focusedArea", void 0);
    __decorate([
        mobx_1.observable
    ], ViewStore.prototype, "customButtons", void 0);
    __decorate([
        mobx_1.observable
    ], ViewStore.prototype, "customActions", void 0);
    __decorate([
        mobx_1.observable
    ], ViewStore.prototype, "disableAnimations", void 0);
    __decorate([
        mobx_1.observable
    ], ViewStore.prototype, "highlightedMessages", void 0);
    __decorate([
        mobx_1.computed
    ], ViewStore.prototype, "showConversationsButton", null);
    __decorate([
        mobx_1.computed
    ], ViewStore.prototype, "showBotInfoButton", null);
    __decorate([
        mobx_1.computed
    ], ViewStore.prototype, "showDownloadButton", null);
    __decorate([
        mobx_1.computed
    ], ViewStore.prototype, "showDeleteConversationButton", null);
    __decorate([
        mobx_1.computed
    ], ViewStore.prototype, "showResetButton", null);
    __decorate([
        mobx_1.computed
    ], ViewStore.prototype, "showCloseButton", null);
    __decorate([
        mobx_1.computed
    ], ViewStore.prototype, "showWidgetButton", null);
    __decorate([
        mobx_1.computed
    ], ViewStore.prototype, "hasUnreadMessages", null);
    __decorate([
        mobx_1.computed
    ], ViewStore.prototype, "isWebchatReady", null);
    __decorate([
        mobx_1.computed
    ], ViewStore.prototype, "isBotInfoDisplayed", null);
    __decorate([
        mobx_1.computed
    ], ViewStore.prototype, "sideTransition", null);
    __decorate([
        mobx_1.computed
    ], ViewStore.prototype, "widgetTransition", null);
    __decorate([
        mobx_1.computed
    ], ViewStore.prototype, "displayWidgetView", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "setFocus", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "focusPrevious", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "focusNext", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "incrementUnread", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "resetUnread", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "toggleBotInfo", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "showBotInfo", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "toggleConversations", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "hideConversations", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "setLoadingCompleted", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "showPoweredBy", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "hidePoweredBy", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "setLayoutWidth", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "setContainerWidth", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "addCustomAction", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "removeCustomAction", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "addHeaderButton", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "setHighlightedMessages", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "updateHeaderButton", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "removeHeaderButton", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "showChat", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "hideChat", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "_endAnimation", null);
    __decorate([
        mobx_1.action.bound
    ], ViewStore.prototype, "_updateTransitions", null);
    return ViewStore;
}());
exports.default = ViewStore;
